import s from "./td-longtail-vue-components232.js";
/* empty css                              */
import a from "./td-longtail-vue-components98.js";
var o = function() {
  var e = this, r = e._self._c, t = e._self._setupProxy;
  return r(t.Dropdown, { ref: "dropdownElement", staticClass: "list-dropdown", class: t.containerClass, attrs: { opened: e.opened, disabled: t.isDisabled, "is-multi-select": e.multiple, label: e.label, "auto-width": e.autoWidth }, on: { toggle: t.onToggle }, scopedSlots: e._u([{ key: "trigger", fn: function(n) {
    return [e._t("trigger", null, null, n)];
  } }, { key: "captionBefore", fn: function() {
    return [t.selectedOption?.before ? r("span", { staticClass: "list-dropdown__caption-before", domProps: { innerHTML: e._s(t.selectedOption?.before) } }) : e._e()];
  }, proxy: !0 }, { key: "caption", fn: function() {
    return [e.labelOnSelection && t.hasSelection ? e._t("selection", function() {
      return [r("span", { staticClass: "sr-only" }, [e._v("Ausgewählt:")]), e._v(" " + e._s(t.selectedLabels) + " ")];
    }, { selection: t.selection }) : e._t("placeholder", function() {
      return [e._v(" " + e._s(e.placeholder) + " ")];
    })];
  }, proxy: !0 }, { key: "input", fn: function({ uid: n }) {
    return [e.hasSearch ? r(t.TextInput, { ref: "searchInputElement", staticClass: "list-dropdown__search-input", attrs: { id: t.uniqueId(), "input-props": {
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-haspopup": "listbox",
      "aria-controls": `dropdown-list${n}`
    }, placeholder: e.placeholderText }, nativeOn: { input: function(l) {
      return t.updateSearchResults.apply(null, arguments);
    } }, model: { value: t.searchInput, callback: function(l) {
      t.searchInput = l;
    }, expression: "searchInput" } }) : e._e()];
  } }, { key: "default", fn: function() {
    return [e._t("default", function() {
      return [r("div", { staticClass: "list-dropdown__items" }, [e.includeBlank ? r(t.DropdownItem, { attrs: { selected: !t.hasSelection, label: e.includeBlank, url: t.buildItemUrl(null) }, on: { click: t.selectAndMaybeChange } }) : e._e(), t.filteredOptions.length === 0 ? [r("span", { staticClass: "btn btn--small-padding btn--is-wide btn--secondary list-dropdown__item-empty", domProps: { innerHTML: e._s(e.emptyText) } })] : [e._l(t.filteredOptions, function(n, l) {
        return [e.groupEntries && (l === 0 || t.filteredOptions[l - 1].groupName !== n.groupName) ? r("div", { key: `groupname_${l}`, staticClass: "btn btn--small-padding btn--secondary list-dropdown__item-group-name", attrs: { "aria-hidden": "true" } }, [e._v(" " + e._s(n.groupName) + " ")]) : e._e(), r(t.DropdownItem, { key: l, attrs: { label: n.label, "aria-label": n.ariaLabel, value: n.value, count: n.count, selected: t.isSelected(n.value), url: t.buildItemUrl(n.value), "break-text": e.breakText }, on: { click: function(d) {
          return t.selectAndMaybeChange(n);
        } }, scopedSlots: e._u([{ key: "beforeLabel", fn: function() {
          return [n.before ? r("span", { staticClass: "list-dropdown__caption-before", domProps: { innerHTML: e._s(n.before) } }) : e._t("beforeLabel", null, { option: n })];
        }, proxy: !0 }], null, !0) })];
      })]], 2)];
    })];
  }, proxy: !0 }, { key: "submit", fn: function() {
    return [e.multiple ? r(t.LinkButton, { attrs: { tag: "button", type: "button", primary: "", "small-padding": "", "is-wide": "", disabled: !t.hasChanged }, on: { click: t.change } }, [e._v(" " + e._s(e.buttonText) + " ")]) : e._e()];
  }, proxy: !0 }], null, !0) });
}, i = [], u = /* @__PURE__ */ a(
  s,
  o,
  i,
  !1,
  null,
  "9752b891"
);
const b = u.exports;
export {
  b as default
};
